class AudioListenerComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { AudioListenerComponentData };
